import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  button {
    margin: auto;
    width: 220px;
  }

  .clickable {
    cursor: pointer;
    color: ${props => props.theme.palette.primary.alphaDark};
    font-weight: bold;

    &:hover {
      opacity: 0.8;
    }
  }

  .actions {
    label {
      display: block;
      margin: 5px 0;

      input {
        margin-right: 5px;
      }
    }
  }
`

export const ColumnsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  ${bp('sm')`
    flex-wrap: wrap;
  `}

  > div {
    flex: 1;
    margin: 0 10px;
    ${bp('sm')`
      width: 100%;
      flex: auto;

      &.r-column {
        margin-top: 30px;
      }
    `}
  }
`
